import {
    AgentCard,
    ContextAndMessagesAndSelectedAndCard, ContextWithQuery, PipelineDetailsData, PipelineExecutors, SelectorContext
} from "@me8eon/agent";
import { makeContextForState } from "@me8eon/context";
import { Errors, ErrorsOr } from "@me8eon/errors";
import { LogAnd } from "@me8eon/errors";

export const intentSearchName = 'aiAssistant'


export type AgentContextType<Context extends ContextWithQuery> = SelectorContext<Context> & {
    executors: PipelineExecutors<Context>
}

export type AiAgentAndPipelineResultsType<Context> = {
    loading?: boolean
    query?: string
    agentResult?: LogAnd<ErrorsOr<ContextAndMessagesAndSelectedAndCard<Context>>>,
    pipeline?: LogAnd<ErrorsOr<PipelineDetailsData<Context>>>,
    errors?: Errors
};

export type AgentSelectorContext = AgentCard<any, any> | undefined;

export type AiStreamingStatus =
    | "idle"
    | "waiting-first-token"
    | "streaming";

export type AiStreamingUiState = {
    status: AiStreamingStatus
    agentName?: string
    content: string
    hasFirstChunk: boolean
    error?: string
};

export const emptyAiStreamingUiState: AiStreamingUiState = {
    status: "idle",
    agentName: undefined,
    content: "",
    hasFirstChunk: false,
    error: undefined
};

export const { use: useAiAgentAndPipelineResults, Provider: AiAgentAndPipelineResultsProvider } =
    makeContextForState<AiAgentAndPipelineResultsType<any>, "aiAgentAndPipelineResults">("aiAgentAndPipelineResults");

export const { use: useAgentSelectorContext, Provider: AgentSelectorContextProvider } =
    makeContextForState<AgentSelectorContext, "agent">("agent", { allowedUndefined: true });

export const { use: useAiStreamingUiState, Provider: AiStreamingUiStateProvider } =
    makeContextForState<AiStreamingUiState, "aiStreamingUiState">("aiStreamingUiState");

export const { use: useSelectedLlmModel, Provider: SelectedLlmModelProvider } =
    makeContextForState<string, "selectedLlmModel">("selectedLlmModel");